import { render } from "./SubscriptionProducts.vue?vue&type=template&id=b71d4a3a&ts=true"
import script from "./SubscriptionProducts.vue?vue&type=script&lang=ts"
export * from "./SubscriptionProducts.vue?vue&type=script&lang=ts"

import "./SubscriptionProducts.vue?vue&type=style&index=0&id=b71d4a3a&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__